import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import { LegalH2 as H2, LegalP as P, LegalUL as UL } from './_legalHelpers';

const VERSION = 'BMJ-REFUND-V1.0-2026-05';

export default function RefundPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const effectiveDate = new Date().toLocaleDateString('en-IN', {
    day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div data-testid="refund-policy-page" className="bg-white min-h-screen">
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/" data-testid="refund-breadcrumb"
            className="inline-flex items-center text-[11px] font-semibold uppercase tracking-[0.2em] text-[#673c96]/70 hover:text-[#f37721] transition-colors mb-8"
            style={{ fontFamily: 'Montserrat, sans-serif' }}>
            ← Back to Home
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#311b52] mb-3"
            style={{ fontFamily: 'Poppins, sans-serif' }}>
            Refund Policy
          </h1>

          <div className="flex flex-col gap-1 mb-10 pb-10 border-b border-[#673c96]/10">
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Effective Date:</span> {effectiveDate}
            </p>
            <p className="text-[13px] text-[#673c96]/80" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              <span className="font-semibold">Version:</span> {VERSION}
            </p>
          </div>

          <P>
            BookMyJab facilitates at-home vaccination through authorised partners. Refund eligibility is as follows:
          </P>

          <H2>Refund Eligibility</H2>
          <UL>
            <li>Bookings cancelled before nurse dispatch are eligible for a full refund of any pre-paid amount, excluding non-refundable processing fees where applicable.</li>
            <li>If vaccine procurement is not possible due to availability, cold-chain or doctor/nurse review, any pre-paid amount will be refunded in full.</li>
            <li>Once the vaccine has been procured and the nurse has been dispatched, administration charges may be retained.</li>
            <li>If administration has been completed, the booking is non-refundable except in cases of proven service failure.</li>
            <li>Refunds are processed to the original payment method within standard banking timelines.</li>
          </UL>

          <H2>How to Raise a Refund Request</H2>
          <P>
            For refund requests or disputes, contact BookMyJab support through the in-app support channel, or email <a href="mailto:bookmyjab@gmail.com" className="text-[#f37721] hover:underline font-medium" data-testid="refund-support-email">bookmyjab@gmail.com</a> with your booking ID and the reason for the request.
          </P>
          <P>
            Phone / WhatsApp: <a href="tel:+919873554343" className="text-[#f37721] hover:underline font-medium">+91 9873 55 4343</a>
          </P>
          <P>
            For unresolved disputes, see <Link to="/grievance" className="text-[#f37721] hover:underline font-medium">Grievance & Data Rights</Link>.
          </P>
        </div>
      </main>
      <Footer />
    </div>
  );
}
